module.exports = __webpack_public_path__ + "static/img/icon_instagram_symbol.e69b48b8.png";